class TypeReport {
    public id: number;
    public eps: string;
    public name: string;
    public description: string;
    public is_active: boolean;
    public eps__name_eps?: string;

    constructor(id: number, eps: string, name: string, description: string, is_active: boolean) {
        this.id = id;
        this.eps = eps;
        this.name = name;
        this.description = description;
        this.is_active = is_active;
    }
}
export default TypeReport;
